import React, { Component } from 'react'
import { connect } from 'react-redux'
import html2canvas from 'html2canvas'
// import * as jsPDF from 'jspdf'
import Voucher from '../../Components/Voucher'
import Loading from '../../../SPRINTA/atoms/Loading'
import * as checkout from '../../utils/checkout'
import style from './style.css'
class Adyen extends Component {
  state = {
    loading: true
  }

  componentWillMount() {
    let token = this.props.match.params.token
    this.setState({
      token,
      loading: true
    })
    checkout.getByToken(token)
    .then(data => {
      if(data.errors && data.errors[0] && data.errors[0].type === 'not_found') {
        window.location.href = window.NOTFOUND
      }

      this.setResponsePayment(data)
    })
  }

  setResponsePayment(data) {
    data.payment.status = parseInt(data.payment.status, 10)
    
    if(data.payment.status < 3) {
      window.location.href = '/'+this.state.token
      return
    }

    this.setState({
      loading: false,
      order: data.order,
      products: data.products,
      payment: data.payment,
      participants: data.participants,
      released: data.released
    })
  }

  donwload() {
    const input = this.refs.print.refs.voucher
    
    html2canvas(input)
    .then((canvas) => {
      const imgData = canvas.toDataURL('image/png')
      const link = document.createElement('a')
      link.href = imgData
      link.download = this.state.token+".png"
      link.click()
      // const pdf = new jsPDF();
      // pdf.addImage(imgData, 'PNG', 0, 0);
      // pdf.save(this.state.token+".pdf");
    })
  }
  
  render() {
    if(this.state.loading) 
    return (
      <div style={{padding: '40px', width: '600px', textAlign: 'center'}}>
        <Loading />
      </div>
    )


    return (
      <div style={{padding: '20px', textAlign: 'center', display: 'inline-block'}}>
        <a href="#print" onClick={e => {
          e.preventDefault()
          window.print()
        }} style={{fontSize: '14px'}} className={style.print}>Imprimir/Print</a>
        <span style={{ margin: '0 20px' }} />
        <a href="#print" onClick={e => {
          e.preventDefault()
          this.donwload()
        }} style={{fontSize: '14px'}} className={style.print}>Download</a>

        <Voucher
          ref='print'
          token={this.state.token}
          title={this.state.order.title}
          confirmationDate={
            this.state.order.confirmationDate
          }
          participants={
            this.state.participants ? this.state.participants.users : null
          }
          extras={
            this.state.products ? this.state.products.itens : null
          }
          />
      </div>
    )
  }
}

const mapStateToProps = store => ({})
const mapDispatchToProps = {

}
export default connect( mapStateToProps, mapDispatchToProps )(Adyen)


// WEBPACK FOOTER //
// ./src/App/pages/Voucher/index.js